// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1477":"19d7c607","6274":"0d29d592","9735":"c73becad"}[chunkId] + ".chunk.css";
};